import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "text-2xl" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Estimated Reward Rate (Variable): ")
const _hoisted_7 = { class: "font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, "Accrued: " + _toDisplayString(_ctx.reward.accruedReward / 1000000000), 1),
    _createElementVNode("div", _hoisted_4, "Total paid out: " + _toDisplayString(_ctx.reward.paidOutReward / 1000000000), 1),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(// divide by two for the first halving
          Math.floor(((264/2) / _ctx.parseNumGems(_ctx.allGems)) * _ctx.parseNumGems(_ctx.yourGems) * 10) / 10) + " $DUST/day ", 1)
      ])
    ])
  ]))
}